import * as React from 'react';
import { StaticPageWrapper, IStaticPageWrapperProps, centeredMessageStyle } from 'components/static-pages/StaticPageWrapper';

export const CounselingPage = (props:IStaticPageWrapperProps) =>
	<StaticPageWrapper 
		backgroundImage="/res_sys/female counselor.jpg" 
		{...props}
	>
		<div style={centeredMessageStyle}>
			<div style={{textAlign:'center',fontFamily:'Open Sans',fontWeight:900,fontSize:'32px',color:'#263692', paddingTop:'20px', paddingBottom:'25px',lineHeight: '32px'}}>NUTRITION COUNSELING</div>
			<div style={{textAlign:'center', marginTop:'0px', marginBottom:'25px'}}>
				<a target="_blank" href="https://wcmember.northtrac.com/sso" className="go_button" aria-label={`GET STARTED, opens new tab`} style={{borderRadius:'40px',boxShadow: '2px 2px 4px 0px rgba(0,0,0,0.5)'}}>GET STARTED</a>
			</div>
			<div style={{fontSize:'18px',fontFamily:'Open Sans',fontWeight:600, fontStyle:'italic',color:'#4A4A4A', textAlign:'center',paddingBottom:'30px'}}>
				Schedule / manage appointments<br/>
				Meet privately with your dietitian<br/>
				Follow up virtually<br/>
				Manage your goals and meal plans
			</div>

		</div>
	</StaticPageWrapper>
;


